import React from 'react'
import Classes from './SectionCards.module.css'
import { motion } from 'framer-motion'

const SupplierIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 640 512"><path d="M256 48c0-26.5 21.5-48 48-48L592 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48l-210.7 0c1.8-5 2.7-10.4 2.7-16l0-242.7c18.6-6.6 32-24.4 32-45.3l0-32c0-26.5-21.5-48-48-48l-112 0 0-80zM571.3 347.3c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 310.6 480 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-121.4 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0zM0 176c0-8.8 7.2-16 16-16l352 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L16 224c-8.8 0-16-7.2-16-16l0-32zm352 80l0 224c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32l0-224 320 0zM144 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0z" /></svg>
)
const InventoryIcon = (props) => (
    <>
        <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 640 512"><path d="M0 488L0 171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4L640 488c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-264c0-17.7-14.3-32-32-32l-384 0c-17.7 0-32 14.3-32 32l0 264c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm488 24l-336 0c-13.3 0-24-10.7-24-24l0-56 384 0 0 56c0 13.3-10.7 24-24 24zM128 400l0-64 384 0 0 64-384 0zm0-96l0-80 384 0 0 80-384 0z" /></svg>
    </>
)
const DeliveryIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 640 512"><path d="M48 0C21.5 0 0 21.5 0 48L0 368c0 26.5 21.5 48 48 48l16 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64 0-32 0-18.7c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7L416 96l0-48c0-26.5-21.5-48-48-48L48 0zM416 160l50.7 0L544 237.3l0 18.7-128 0 0-96zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" /></svg>
)

export default function SectionCards() {
    return (
        <div id='features' className={Classes.hero} >
            <div className={Classes.miniText} > Key Features </div>
            <h1 className={Classes.subheading}> Authentic UAE-Crafted Footwear </h1>
            <p className={Classes.text}>
                We partner with verified factories Vietnam manufacturers to bring you premium, stylish footwear <br /> made with expert craftsmanship and the finest materials.
            </p>

            <div className={Classes.cardsCon} >
                <div className={Classes.card} >
                    <div className={Classes.imageCon} >
                        <SupplierIcon height='30px' width='30px' fill='white' />
                    </div>
                    <h3>Verified <br /> Suppliers Only</h3>
                    <h5>Each pair of shoes is sourced directly from certified Vietnam manufacturers, ensuring authenticity, durability, and consistent quality.</h5>
                </div>
                <div className={`${Classes.card} ${Classes.greenCard}`} >
                    <div className={Classes.imageCon} >
                        <InventoryIcon height='30px' width='30px' fill='white' />
                    </div>
                    <h3>Quality-Checked <br /> Inventory</h3>
                    <h5>All items go through strict quality checks before being listed on our site — no compromises, just top-tier shoes.</h5>
                </div>
                <div className={Classes.card} >
                    <div className={Classes.imageCon} >
                        <DeliveryIcon height='30px' width='30px' fill='white' />
                    </div>
                    <h3>Super Fast <br /> Shipping</h3>
                    <h5>We process and ship your order within 24 hours, so your style upgrade doesn’t have to wait.</h5>
                </div>
            </div>

            <motion.div
                whileTap={{ scale: 0.97 }}
                whileHover={{ scale: 1.03 }}
            >
                <a href='/all-products' >
                    <button className={Classes.startBtn} > <h5>Explore Our Inventory</h5> </button>
                </a>
            </motion.div>
        </div>
    )
}
